import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex-shrink-0" }
const _hoisted_3 = { class: "flex flex-col w-full gap-3 ml-3" }
const _hoisted_4 = {
  key: 1,
  class: "w-full"
}
const _hoisted_5 = { class: "ml-auto pl-3" }
const _hoisted_6 = { class: "-mx-1.5 -my-1.5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Dismiss", -1)

import { computed } from "vue"
import GgmsProgressBar from "@/components/GgmsProgressBar.vue"
import { CheckCircleIcon, ExclamationIcon, XCircleIcon, XIcon, InformationCircleIcon } from "@heroicons/vue/solid"
import { ToastModel } from "@/shared/models/toast-model"

interface Props {
    toast: ToastModel
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsToast',
  props: {
    toast: {}
  },
  emits: ["clickClose"],
  setup(__props: any) {

const props = __props



const getAttributes = computed(() => {
    if (props.toast.type === "success")
        return {
            toastBackground: "bg-green-50",
            text500: "text-green-500",
            text800: "text-green-800",
            hoverBackGround100: "hover:bg-green-100",
            focusRingOffset50: "focus:ring-offset-green-50",
            focusRing50: "focus:ring-green-600",
            icon: CheckCircleIcon,
            iconColor: "text-green-400",
        }

    if (props.toast.type === "error")
        return {
            toastBackground: "bg-red-50",
            text500: "text-red-500",
            text800: "text-red-800",
            hoverBackGround100: "hover:bg-red-100",
            focusRingOffset50: "focus:ring-offset-red-50",
            focusRing50: "focus:ring-red-600",
            icon: XCircleIcon,
            iconColor: "text-red-400",
        }

    if (props.toast.type === "warning")
        return {
            toastBackground: "bg-yellow-50",
            text500: "text-yellow-500",
            text800: "text-yellow-800",
            hoverBackGround100: "hover:bg-yellow-100",
            focusRingOffset50: "focus:ring-offset-yellow-50",
            focusRing50: "focus:ring-yellow-600",
            icon: ExclamationIcon,
            iconColor: "text-yellow-400",
        }

    if (props.toast.type === "info")
        return {
            toastBackground: "bg-primary-color-50",
            text500: "text-primary-color-600",
            text800: "text-primary-color-800",
            hoverBackGround100: "hover:bg-primary-color-100",
            focusRingOffset50: "focus:ring-offset-primary-color-50",
            focusRing50: "focus:ring-primary-color-600",
            icon: InformationCircleIcon,
            iconColor: "text-primary-color-600",
        }
    if (props.toast.type === "notification") {
        return {
            toastBackground: "bg-primary-color-500",
            text500: "text-gray-300",
            text800: "text-white",
            hoverBackGround100: "hover:bg-primary-color-100",
            focusRingOffset50: "focus:ring-offset-primary-color-50",
            focusRing50: "focus:ring-primary-color-600",
        }
    }
    return {}
})

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["max-w-sm w-full p-4 shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden", getAttributes.value.toastBackground])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(getAttributes.value.icon), {
          class: _normalizeClass(["h-5 w-5", getAttributes.value.iconColor]),
          "aria-hidden": "true"
        }, null, 8, ["class"]))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", {
          class: _normalizeClass(["text-sm font-medium", [getAttributes.value.text800]])
        }, _toDisplayString(_ctx.toast.message), 3),
        (_ctx.toast.description)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(["text-sm font-medium", [getAttributes.value.text500]])
            }, _toDisplayString(_ctx.toast.description), 3))
          : _createCommentVNode("", true),
        (_ctx.toast.percentage !== null && _ctx.toast.percentage !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(GgmsProgressBar, {
                class: "flex-1",
                isProgressNumberVisible: true,
                progress: _ctx.toast.percentage,
                progressSuffix: "%",
                "bar-color": "bg-white",
                progressNumberColor: "text-white"
              }, null, 8, ["progress"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clickClose'))),
            type: "button",
            class: _normalizeClass(["inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2", [
                            getAttributes.value.toastBackground,
                            getAttributes.value.text500,
                            getAttributes.value.hoverBackGround100,
                            getAttributes.value.focusRingOffset50,
                            getAttributes.value.focusRing50,
                        ]])
          }, [
            _hoisted_7,
            _createVNode(_unref(XIcon), {
              class: "h-5 w-5",
              "aria-hidden": "true"
            })
          ], 2)
        ])
      ])
    ])
  ], 2)), [
    [_vShow, _ctx.toast.timer || _ctx.toast.persistent]
  ])
}
}

})